<template>
	<div class="m-search">
		<div class="m-search-hadnle flex-center-cross">
			<c-button @click="search">查询</c-button>
			<c-button color="black" hollow @click="clear">重置条件</c-button>
		</div>
		<div class="m-search-content" :style="{'max-height': foldState ? '80px' : 'none'}">
			<div ref="content">
				<slot></slot>
			</div>
		</div>
		<div v-if="height > 80" class="m-search-fold flex-center" :class="{'z-fold': foldState}" @click="foldState = foldState ? 0 : 1"><i class="tf">&#xe686;</i></div>
	</div>
</template>

<script>
	export default {
		name: 'mSearch',
		
		props: {
			fold: {
				type: Boolean,
				default: true
			}
		},
		
		data() {
			return {
				height: 1,
				foldState: false
			}
		},
		
		watch: {
			foldState(val) {
				if (val !== false) {
					localStorage.setItem('searchFoldState', val);
				}
			}
		},
		
		mounted() {
			this.$form = this.$children.find(item => item.$options.name == 'cForm');

			if (this.fold) {
				this.initFold();
			}
		},
		
		beforeDestroy() {
			this._ob && this._ob.disconnect();
		},

		methods: {
			initFold() {
				this.foldState = parseInt(localStorage.getItem('searchFoldState')) || 0;
				this._ob = new ResizeObserver(entries => {
					for (const entry of entries) {
						this.height = entry.contentRect.height;
					}
				}).observe(this.$refs.content);
			},
			
			search() {
				var data = this.$form.serialize();
				this.$emit('search', data);
			},
			
			get() {
				return this.$form.serialize();
			},
			
			clear() {
				this.$form.clear();
			}
		}
	}
</script>

<style lang="stylus">
	@import './style/search'
</style>
